export function LightMode({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="106"
        height="131"
        viewBox="0 0 106 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="selection-ring"
          x="0.828125"
          y="0.828125"
          width="104.344"
          height="129.188"
          rx="14.0781"
          stroke="var(--clr-general-primary)"
          strokeWidth="1.65625"
        />
        <rect
          x="4.96875"
          y="4.96875"
          width="96.0625"
          height="120.906"
          rx="10.7656"
          fill="var(--clr-white)"
          stroke="#E3E3E3"
          strokeWidth="1.65625"
        />
        <rect
          x="14.0781"
          y="14.0781"
          width="36.4375"
          height="4.96875"
          rx="2.48438"
          fill="#CED0DB"
        />
        <circle cx="89.4376" cy="16.5621" r="2.65" fill="#CED0DB" />
        <rect x="12.4219" y="28.9844" width="81.1562" height="1.24219" fill="#E3E3E3" />
        <rect x="14.0781" y="38.9219" width="66.25" height="4.14062" rx="2.07031" fill="#CED0DB" />
        <rect x="14.0781" y="48.8594" width="53" height="4.14062" rx="2.07031" fill="#CED0DB" />
        <rect
          x="14.0781"
          y="58.7969"
          width="43.0625"
          height="4.14062"
          rx="2.07031"
          fill="var(--clr-general-primary)"
        />
        <rect x="14.0781" y="68.7344" width="59.625" height="4.14062" rx="2.07031" fill="#CED0DB" />
        <rect
          x="14.0781"
          y="78.6719"
          width="48.0312"
          height="4.14062"
          rx="2.07031"
          fill="#CED0DB"
        />
        <rect
          x="14.0781"
          y="103.516"
          width="77.8438"
          height="13.25"
          rx="6.625"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
